import { render } from "./CardHeaderComponent.vue?vue&type=template&id=b15de6c6&scoped=true"
import script from "./CardHeaderComponent.vue?vue&type=script&lang=js"
export * from "./CardHeaderComponent.vue?vue&type=script&lang=js"

import "./CardHeaderComponent.vue?vue&type=style&index=0&id=b15de6c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15de6c6"]])

export default __exports__